import { render, staticRenderFns } from "./DataFormatEditor.vue?vue&type=template&id=4fe32dcb&scoped=true"
import script from "./DataFormatEditor.vue?vue&type=script&lang=js"
export * from "./DataFormatEditor.vue?vue&type=script&lang=js"
import style0 from "./DataFormatEditor.vue?vue&type=style&index=0&id=4fe32dcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe32dcb",
  null
  
)

export default component.exports